import { HubJsonRpcRequest } from '../api/HubJsonRpcRequest';
import { HubApiMethods } from '../constants/HubApiMethods';
import { CurrentUser } from '../general/modules/user/currentUser';
import { HubApiRequestError } from '../api/HubApiRequestError';
import { ClusterConfig } from '../types/server';
import { container } from '../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../utils/container/service-ids';
import { FlagNames } from '../utils/feature-flags/flag-names';
import { getHubApi } from '../general/modules/accountServiceApi/getAccountServiceApi';

type GetMaintenanceDataResponse = {
    cluster: ClusterConfig
    maintenanceData: {
        isOn: boolean,
        startTime: number
    },
    staticBaseUrl: string
    compensationStaticUrl: string
};

type GetMaintenanceDataRequest = {
    suid: string,
    token: string,
    cluster: string
}

export class MaintenanceMode {
    public static async getStateData(): Promise<GetMaintenanceDataResponse> {
        const currentUser = CurrentUser.getInstance();
        const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
        const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();

        let response;

        try {
            if (!isHubApiEnabled) {
                response = await HubJsonRpcRequest.makeRequest<GetMaintenanceDataResponse, GetMaintenanceDataRequest>(
                    HubApiMethods.GET_MAINTENANCE_DATA,
                    {
                        cluster: window.app.config.cluster_name,
                        suid: String(currentUser.getSuid()),
                        token: currentUser.getAuthToken()
                    },
                    window.app.deviceIdentifier
                );

                if ('error' in response) {
                    throw new HubApiRequestError(response.error.message);
                }
            } else {
                const hubApi = getHubApi();
                response = await hubApi.getMaintenanceData(window.app.deviceIdentifier) as GetMaintenanceDataResponse;
            }

            return response;
        } catch (error) {
            throw new HubApiRequestError(error.message);
        }
    }
}
